//@flow
import {useState, useEffect} from 'react';

import {fetchContactSummaryService} from '../promises';
import type {ContactSummaryFilters} from '../promises';
import type {Pagination} from '../../../../entities';
import type {ContactSummaryItem} from '../../../../entities/crm/contact';
import {contactSummaryAdapter} from './contact-summary-adapter';

export function useContactSummary() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [contacts, setContacts] = useState<ContactSummaryItem[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);

  const [tableFilter, setTableFilter] = useState<ContactSummaryFilters>({
    page: 0,
    size: 5,
  });

  useEffect(() => {
    setLoading(true);
    fetchContactSummaryService(tableFilter)
      .then(response => {
        const data = response.data;
        const formattedItems = data.map(contactSummaryAdapter);
        setContacts(formattedItems);
        setPagination(response.pagination ?? null);
      })
      .catch(error => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [tableFilter]);

  const setFilterContacts = (filters: ContactSummaryFilters) => {
    setTableFilter({...tableFilter, ...filters});
  };

  return {loading, error, contacts, pagination, setFilterContacts};
}
